import { createApi, createDomain } from 'effector';
import type { SeatItem } from '@modules/header/ShareConfigModal/types';

const domain = createDomain('seats');

export const $seatsSelected = domain.store<SeatItem[]>([]);
export const $seatsSelectedApi = createApi($seatsSelected, {
  init: (store, payload: SeatItem[]) => payload,
  add: (state, payload: SeatItem) => {
    return [...state, payload];
  },
  remove: (
    state,
    payload: {
      relationId: SeatItem['id'];
      accessScope: SeatItem['accessScope'];
    }
  ) => {
    return state.filter(
      (x) =>
        !(
          x.relationId === payload.relationId &&
          x.accessScope === payload.accessScope
        )
    );
  },
  clear: () => [],
});

export const $seatsSpcialIds = domain.store<{
  ownerId?: number;
  operatorId?: number;
}>({});
export const $seatsSpcialIdsApi = createApi($seatsSpcialIds, {
  set: (
    state,
    payload: {
      ownerId?: number;
      operatorId?: number;
    }
  ) => {
    return { ...state, ...payload };
  },
});
